import GroupAddress from "../models/GroupAdress";
import AddressGeneratorUtils from "./AddressGeneratorUtils";
import Button from "../models/Button";
import ButtonChannel from "../models/ButtonChannel";
import { getSignalTypeBundle } from "../models/SignalBundles";

import Logger from "../Logger";
import GroupAddressNameGenerator from "./GroupAddressNameGenerator";

const logger = new Logger();

export function createButtonAddresses_3(button: Button, level2ParentGroup: GroupAddress) {
  button.buttonChannels.forEach((buttonChannel) => {
    if (buttonChannel.isGroupButtonChannel) {
      //
      // if a buttonChannel has than 1 connection
      // it a group
      // and we have to create "group" groupAdresses for this Button
      //
      const knxChannel = buttonChannel.mappedChannel as ButtonChannel;
      if (knxChannel) {
        createGroupButtonChannelAddresses(button, buttonChannel, knxChannel, level2ParentGroup);
      }
    }
  });
}

function createGroupButtonChannelAddresses(
  button: Button,
  buttonChannel: ButtonChannel,
  knxButtonChannel: ButtonChannel,
  level2Group: GroupAddress,
) {
  // buttonChannel.signals.clear();

  const signalTypes = getSignalTypeBundle(buttonChannel.channelType);
  signalTypes.forEach((signalType) => {
    if (!signalType.isStatus) {
      //
      // Groups may contain only Commands.
      // the staus of a button has to been taken from the first consumer of the group
      //
      const knxButtonSignal = knxButtonChannel.getSignalByType(signalType);
      if (knxButtonSignal) {
        const name = state.settings.groupAddressNameGenerator.generateGroupAddressNameForButtonChannel(buttonChannel, knxButtonSignal);

        let level3GroupAddress =
          knxButtonSignal?.requestSignal?.groupAddresses.firstItem ||
          knxButtonSignal?.requestSignal?.lastGroupAddresses?.firstItem;

        //
        // if groupAddress would finish under a new parent,
        // ignore it....
        // we have to construct a new one
        //
        // This is especially important for the case,
        // that a button is changing from a "single"  to "group" or visa versa.
        //

        if (level3GroupAddress && level3GroupAddress.parent != level2Group) {
          level3GroupAddress = undefined;
        }

        if (!level3GroupAddress) {
          level3GroupAddress = GroupAddress.createNewGroupAddress({
            level: 3,
            name: name,
            parent: level2Group,
          });
        } else {
          level2Group.children.addWithoutUpdate(level3GroupAddress);
          level3GroupAddress.parent = level2Group;
          level3GroupAddress.name = name;
        }

        level3GroupAddress.isStatus = false;
        level3GroupAddress.generatorObject = buttonChannel;

        AddressGeneratorUtils.attachGroupAddressToSignal(knxButtonSignal, level3GroupAddress);

        logger.log("ButtonAddress generated: ", level3GroupAddress.fullAddress, level3GroupAddress.name);
      }
    }
  });
}
